module.exports = __webpack_public_path__ + "static/img/monkey.dd574f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/monkey.jpg
// module id = HeK5
// module chunks = 1